import { render, staticRenderFns } from "./BabyCubeDetails2.vue?vue&type=template&id=155f0ec2"
import script from "./BabyCubeDetails2.vue?vue&type=script&lang=js"
export * from "./BabyCubeDetails2.vue?vue&type=script&lang=js"
import style0 from "./BabyCubeDetails2.vue?vue&type=style&index=0&id=155f0ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports